import React from "react";
import { FormatMessage } from "react-globalize";

const locations = ["Abilene",
"Alvin",
"Amarillo",
"Andrews",
"Arcola",
"Arlington",
"Austin",
"Baytown",
"Beverly Hills",
"Bovina",
"Brownfield",
"Bryan",
"Cactus",
"Caldwell",
"Canton",
"Carrollton",
"Channelview",
"Cleburne",
"Cleveland",
"Clute",
"Comanche",
"Conroe",
"Copperas Cove",
"Corpus Christi",
"Corsicana",
"Cottonwood Shores",
"Coyanosa",
"Crane",
"Cypress",
"Dalhart",
"Dallas",
"Denton",
"Denver City",
"Dickinson",
"Dimmitt",
"Donna",
"Dublin",
"Dumas",
"Duncanville",
"Eastland",
"Edinburg",
"Elgin",
"Ennis",
"Euless",
"Farwell",
"Ferris",
"Florence",
"Fort Worth",
"Friona",
"Frisco",
"Galveston",
"Garland",
"Georgetown",
"Gilmer",
"Granbury",
"Grand Prairie",
"Granite Shoals",
"Greenville",
"Groesbeck",
"Haltom City",
"Henderson",
"Hereford",
"Hillsboro",
"Hockley",
"Houston",
"Humble",
"Huntsville",
"Ingram",
"Irving",
"Katy",
"Jarell",
"Jewett",
"Karnes City",
"Kermit",
"Killeen",
"Lake Dallas",
"Lancaster",
"Laredo",
"League City",
"Leander",
"Lewisville",
"Little Elm",
"Livingston",
"Lockhart",
"Longview",
"Mansfield",
"Marble Falls",
"Marshall",
"Mesquite",
"Mexia",
"Midland",
"Mineola",
"Mineral Wells",
"Mission",
"Muleshoe",
"New Braunfels",
"New Caney",
"Odessa",
"Pampa",
"Paris",
"Pasadena",
"Pearland",
"Pecos",
"Perryton",
"Pharr",
"Pinehurst",
"Plainview",
"Plano",
"Port Arthur",
"Porter",
"Richardson",
"Round Rock",
"San Angelo",
"San Antonio",
"San Saba",
"Seagoville",
"Sherman",
"Slaton",
"Snyder",
"South Houston",
"Spearman",
"Splendora",
"Spring",
"Springtown",
"Stafford",
"Stephenville",
"Sterling City",
"Stratford",
"Sweetwater",
"Terrell",
"Texas City",
"Tomball",
"Tyler",
"Victoria",
"Waco",
"Waskom",
"Weatherford",
"Webster",
"Wheeler",
"Wylie"];

const columnLenght = Math.ceil(locations.length / 4);

export default function SectionLocationsInTexas(props)
{
  return (<section id="section12" className="content-section about-section sectionPage">
    <div className="row">
      <div className="col-lg-8 col-lg-offset-2 col-sm-10 col-sm-offset-1">
        <div className="title-v1">
            <div className="col-sm-12   col-xs-12">
              <h1 className="text-center">
                <FormatMessage locale={props.locale} path="locationsInTexasPage/title" />
              </h1>
            <hr className="small"/>
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="row-no-gutters col-lg-8 col-lg-offset-2 col-sm-10 col-sm-offset-2 col-xs-offset-3">
        {
          locations.reduce((locationColumns, location, index) => {
              const firstColumnToAdd = Math.floor(index / (columnLenght * 2));
              const secondColumnToAdd = Math.floor(index / columnLenght) % 2;
              locationColumns[firstColumnToAdd][secondColumnToAdd].push(location);
              return locationColumns;
            }, [[[], []], [[], []]])
          .map((outterColumnsGroup) => 
              <div className="col-xs-12 col-sm-6 col-md-6">
                {
                outterColumnsGroup.map(
                  innerColumnsGroup => 
                    <div className="col-xs-12 col-sm-12 col-md-6">{
                        innerColumnsGroup.map(location => <div>{location}</div>)
                        }</div>
            )}</div>
          )}
      </div>
    </div>
  </section>);
  }



// WEBPACK FOOTER //
// ./js/sectionLocationsInTexas.js